import { render, staticRenderFns } from "./ListaAssociados.vue?vue&type=template&id=25147f6d&scoped=true&"
import script from "./ListaAssociados.vue?vue&type=script&lang=js&"
export * from "./ListaAssociados.vue?vue&type=script&lang=js&"
import style0 from "./ListaAssociados.vue?vue&type=style&index=0&id=25147f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25147f6d",
  null
  
)

export default component.exports